export default{
    lista:{
        method:'get',
        url:'trabalhador/epi/lista'
    },
    listatrabalhador:{
        method:'get',
        url:'trabalhador/pesquisa{/id}'
    },
    listatomador:{
        method:'get',
        url:'tomador/pesquisa{/id}'
    },
    cadastra:{
        method:'post',
        url:'trabalhador/epi/cadastro'
    },
    delete:{
        method:'delete',
        url:'trabalhador/epi/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'trabalhador/epi/editar{/id}'
    },
    update:{
        method:'post',
        url:'trabalhador/epi/update'
    }
}